module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./PartnerView.js"));
	}, "PartnerView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=PartnerView!./src/pages/Learn/My/Partner/PartnerView.js
// module id = 2209
// module chunks = 367